/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Views_Scope_PersonalInputs */

const en_views_scope_personal = /** @type {(inputs: Views_Scope_PersonalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only me`)
};

const de_views_scope_personal = /** @type {(inputs: Views_Scope_PersonalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur ich`)
};

/**
* | output |
* | --- |
* | "Only me" |
*
* @param {Views_Scope_PersonalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const views_scope_personal = /** @type {((inputs?: Views_Scope_PersonalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Views_Scope_PersonalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_views_scope_personal(inputs)
	return en_views_scope_personal(inputs)
});